// src/utils/api.js

// Берём из localStorage.user: { accessToken, refreshToken, … }
function getStoredUser() {
    return JSON.parse(localStorage.getItem('user') || '{}');
  }
  
  // Сохраняем новый accessToken в localStorage.user
  function saveAccessToken(newToken) {
    const user = getStoredUser();
    localStorage.setItem('user', JSON.stringify({ ...user, accessToken: newToken }));
  }
  
  // Основная функция-обёртка
  export async function fetchWithAuth(url, options = {}) {
    const user = getStoredUser();
    const token = user.accessToken;
  
    // Добавляем заголовки
    const fetchOptions = {
      cache: 'no-store',       // <<< добавлено, чтобы всегда получать 200 с телом, а не 304
      ...options,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...(options.headers || {}),
      },
    };
  
    // 1) Первый запрос
    let response = await fetch(url, fetchOptions);
  
    // 2) Если 401 — пробуем обновить Access‑токен
    if (response.status === 401) {
      const refreshToken = user.refreshToken;
      if (!refreshToken) {
        // нет refresh — выкидываем на логин
        localStorage.removeItem('user');
        window.location.href = '/login';
        return response;
      }
  
      // Запрос на обновление
      const refreshRes = await fetch('/api/auth/refresh-token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken }),
      });
  
      if (refreshRes.ok) {
        const { accessToken: newToken } = await refreshRes.json();
        saveAccessToken(newToken);
  
        // 3) Повторяем оригинальный запрос с новым токеном
        fetchOptions.headers.Authorization = `Bearer ${newToken}`;
        response = await fetch(url, fetchOptions);
      } else {
        // Refresh тоже не прошёл — выкидываем на логин
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
  
    return response;
  }
  